import { Color, Spacing, TextInput, TextInputProps } from 'zens-storybook'
import React, { useCallback, useState } from 'react'
import { FlatList, ListRenderItem, StyleProp, StyleSheet, View, ViewStyle } from 'react-native'
import { Country, GeoResult, useStore } from 'zens-store'
import { debounce } from '@dms/helper'

import Result from './result'

const styles = StyleSheet.create({
  list: {
    borderColor: Color.calmGrey,
    borderWidth: 1,
    paddingVertical: Spacing.XS,
  },
})

interface Props extends Omit<TextInputProps, 'style' | 'value' | 'onChange'> {
  style?: StyleProp<ViewStyle>
  value?: Country
  onChange?: (code?: Country) => void
}
const CountryInput = (props: Props) => {
  const { value, style, onChange, ...otherData } = props
  const { geo } = useStore()
  const [country, setCountry] = useState<Country | undefined>(value)
  const [results, setResults] = useState<GeoResult[]>([])

  const search = useCallback(
    debounce(async (value: string) => {
      if (value.length >= 3 && !geo.searchPlace.inProgress) {
        setResults((await geo.searchCountry(value)) || [])
      } else {
        setResults([])
      }
    }, 600),
    [],
  )

  const update = (value: string) => {
    search(value)
    setCountry({ code: country?.code || '', title: value })
  }

  const select = (result: GeoResult) => async () => {
    const place = await geo.getPlace(result.placeId)
    const newValue =
      (place &&
        ({
          title: place.country,
          code: place.countryCode,
        } as Country)) ||
      undefined
    setResults([])
    setCountry(newValue)
    onChange?.(newValue)
  }

  const renderResult: ListRenderItem<GeoResult> = (info) => {
    const { item } = info
    return <Result result={item} onPress={select(item)} testID="CountryInput.Row" />
  }

  return (
    <View style={style}>
      <TextInput value={country?.title || ''} onChangeText={update} {...otherData} />
      <FlatList data={results} renderItem={renderResult} contentContainerStyle={results?.length > 0 && styles.list} />
      <View nativeID="map" />
    </View>
  )
}

export default CountryInput
